import { render } from "./PaymentsComponent.vue?vue&type=template&id=73e8bb66&scoped=true"
import script from "./PaymentsComponent.vue?vue&type=script&lang=js"
export * from "./PaymentsComponent.vue?vue&type=script&lang=js"

import "./PaymentsComponent.vue?vue&type=style&index=0&id=73e8bb66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e8bb66"]])

export default __exports__